import {Form, InputGroup} from "@themesberg/react-bootstrap";
import label from 'enqc-utilities/src/label/Label'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import PropTypes from 'prop-types';

export default class TextAreaInput extends React.Component{

    render() {
        let {id, placeholder, label, value, rows, readOnly, icon, isError, errorMessage} = this.props
        if(!id){
            id = "text"
        }
        if(!label){
            label = ""
        }
        if(!placeholder){
            placeholder = label
        }
        if(!rows){
            rows = 3
        }
        return (
            <Form.Group id={id} className="mb-4">
                <Form.Label>{label}</Form.Label>
                <InputGroup>
                    {icon&&(
                        <InputGroup.Text style={{borderColor:(isError?'#FA5252':'')}}>
                            <FontAwesomeIcon icon={icon} />
                        </InputGroup.Text>
                    )}
                    <Form.Control
                        autoFocus
                        required={this.props.required}
                        as="textarea"
                        rows={rows}
                        placeholder={placeholder}
                        onChange={(e)=>{
                            if(this.props.onChange){
                                this.props.onChange(e.target.value)
                            }
                        }}
                        isInvalid={isError}
                        value={value} readOnly={readOnly}
                        onClick={this.props.onClick}
                        style={this.props.style}
                    />
                </InputGroup>
                {isError&&(
                    <Form.Control.Feedback type="invalid" style={{display:'unset', position:'absolute'}}>{errorMessage?errorMessage:placeholder}</Form.Control.Feedback>
                )}
            </Form.Group>
        );
    }
}
TextAreaInput.propTypes = {
    label:PropTypes.string.isRequired,
    value:PropTypes.string,
    placeholder:PropTypes.string,
    icon:PropTypes.any,
    required:PropTypes.bool,
    rows:PropTypes.number,
    readOnly:PropTypes.bool,
    onChange:PropTypes.func,
    isError:PropTypes.bool,
    errorMessage:PropTypes.string
}